import moment from '../../../../utils/moment';
import React, { useMemo } from 'react';
import useStyles from './style';
import { compareDates, inRange } from '../../../../utils/date';
import { isCypress } from 'src/utils/useCypress';

type DateItemType = {
  index?: any;
  weekNumberMode?: any;
  date?: any;
  setDate?: any;
  currentSelectedDate?: any;
  presetDateRange?: any;
  dateRange?: any;
  start?: any;
  end?: any;
  handleClose: any;
};

const DateItem: React.FunctionComponent<DateItemType> = ({index, weekNumberMode, date, setDate, currentSelectedDate, presetDateRange, dateRange, start = false, end = false, handleClose}) => {
  
  const isWeekNumber = useMemo(() => !weekNumberMode ? false : index % 8 === 0, [index]);
  
  const isInDateRange = useMemo(() => inRange(date, dateRange), [date, dateRange]);

  const classes = useStyles({ 
    weekNumberMode: weekNumberMode,
    isWeekNumber: isWeekNumber,
    start: start,
    date: date,
    presetDateRange: presetDateRange,
    dateRange: dateRange,
    end: end,
    moment: moment,
  });

  const handleClick = () => {
    if(start) {
      if(!isWeekNumber){
        setDate(date);
        handleClose();
      }
    } else {
      if(presetDateRange.start != null) {
        if(moment(date).isSameOrAfter(moment(dateRange.start),'day')) {
          if(!isWeekNumber){
            setDate(date);
            handleClose();
          }
        }
      } else {
        if(!isWeekNumber){
          setDate(date);
          handleClose();
        }    
      }
    }
  };

  return (
    <div className={`${classes.root} ${weekNumberMode && isWeekNumber && 'weekNumber'} ${(moment(currentSelectedDate).isSame(moment(date),'day')) && 'selected'} ${(isInDateRange === 'SINGLE' || isInDateRange === 'ERR')&& compareDates(date, currentSelectedDate) && 'single'} ${isInDateRange === 'IN' && 'range'} ${(isInDateRange === 'IN' || isInDateRange === 'START' || isInDateRange === 'END') && date.day() === 0 && 'start'} ${(isInDateRange === 'IN' || isInDateRange === 'END' || isInDateRange === 'START') && date.day() === 6 && 'end'} ${isInDateRange === 'START' && 'start'} ${isInDateRange === 'END' && 'end'}}`} onClick={handleClick} data-cy={isCypress() ? "calendarDayItem-" + moment(date).format("YYYY-MM-DD") : null}>
      <span className={`${classes.date} ${weekNumberMode && isWeekNumber && 'weekNumber'} ${(compareDates(moment(), date)) && !isWeekNumber && 'today'} ${(moment(currentSelectedDate).isSame(moment(date),'day')) && !isWeekNumber &&  'selected'}`}>
        <p data-clarity-unmask="true">{(weekNumberMode && isWeekNumber) ? date.week() : date.date()}</p>
      </span>
    </div>
  );
};

export default DateItem;